// extracted by mini-css-extract-plugin
export default {"root":"MainPanelHeader_root__nFS7i","title":"MainPanelHeader_title__98TKH"};